// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"78687f6d","407":"88d195ac","663":"5d98754b","828":"78687f6d"}[chunkId] + ".css";
};